import { createClient } from '@supabase/supabase-js';

// Valores de respaldo para evitar que la app se quede en blanco si las
// variables de entorno no están disponibles. En producción se usan siempre
// los valores reales de .env.
const supabaseUrl =
  (import.meta.env.VITE_PUBLIC_SUPABASE_URL as string) ||
  'https://placeholder.supabase.co';
const supabaseAnonKey =
  (import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string) ||
  'public-anon-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);